import { Component, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter()
  production = environment.production;
  clientName = environment.clientName;

  constructor() { }

  toggleSideBar(){
    this.toggleSideBarForMe.emit();
  }
}
